// PlanSwitchModal Component
// Confirmation modal for switching plans

import React from 'react';
import { RevoltModal } from '../../../components/RevoltModal';
import { RevoltButton } from '../../../components/RevoltButton';
import { PlanSwitchCard } from './PlanSwitchCard';

export function PlanSwitchModal({
  isOpen,
  onClose,
  onConfirm,
  currentPlan,
  newPlan,
  message = "Switching will cancel your current subscription immediately and activate the new plan right away. Your credits won’t go down. If the new plan includes more monthly credits than you have now, we’ll top you up to that amount.",
}) {
  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm();
    }
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title="Switch Plan"
      showCloseButton={false}
      containerClassName="plan-switch-modal"
    >
      <div>
        {/* Plan Cards Side-by-Side with Arrow */}
        <div
          className="plan-cards-container"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            marginBottom: '24px',
            flexWrap: 'nowrap',
          }}
        >
          {/* Current Plan Card */}
          <PlanSwitchCard 
            planData={currentPlan}
            billingCycle={currentPlan?.billingCycle}
          />

          {/* Arrow */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '48px',
            height: '48px',
            flexShrink: 0,
          }}>
            <svg
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{
                color: '#8b0000',
              }}
            >
              <path
                d="M9 18L15 12L9 6"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          {/* New Plan Card */}
          <PlanSwitchCard 
            planData={newPlan}
            billingCycle={newPlan?.billingCycle}
          />
        </div>

        {/* Message */}
        <p style={{ 
          color: 'rgb(204, 204, 204)',
          fontSize: '15px',
          lineHeight: '1.6',
          textAlign: 'center',
          maxWidth: '700px',
          margin: '0 auto 20px',
        }}>
          {message}
        </p>

        {/* Action Buttons */}
        <div style={{ 
          display: 'flex', 
          gap: '12px', 
          justifyContent: 'flex-end' 
        }}>
          <RevoltButton
            variant="outline"
            onClick={handleCancel}
          >
            Cancel
          </RevoltButton>
          <RevoltButton
            variant="primary"
            onClick={handleConfirm}
          >
            Switch Plan
          </RevoltButton>
        </div>
      </div>
    </RevoltModal>
  );
}

export default PlanSwitchModal;
